<template>
  <v-sheet
     class="d-flex align-center justify-center flex-wrap text-center mx-auto my-2 px-4"
     elevation="4"
     height="200"
     rounded
     max-width="350"
     width="100%"
 >
 <v-img
                  src="@/assets/ab.png"
                  alt="Imagen"
                  class="img"
              ></v-img>
 </v-sheet>


 <v-card>
   <v-tabs
     v-model="tab"
     bg-color="blue-grey"
   >
     <v-tab value="one">oficiales</v-tab>
     <v-tab value="two">suboficiales y sargentos</v-tab>
     <v-tab value="three"></v-tab>
   </v-tabs>

   <v-card-text>
     <v-window v-model="tab">
       <v-window-item value="one">
         <OficialesPage />
       </v-window-item>

       <v-window-item value="two">
         <SuboficialesPage/>
       </v-window-item>

       <v-window-item value="three">
         
       </v-window-item>
     </v-window>
   </v-card-text>
 </v-card>
</template>

<script >
import { defineComponent } from 'vue';

import OficialesPage from './armada/OficialesPage.vue';
import SuboficialesPage from './armada/SuboficialesPage.vue';

 export default defineComponent ({
   data: () => ({
     tab: null,
   }),
   components: {
     OficialesPage,
     SuboficialesPage
},
 });
</script>